import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { linkButton } from './LinkButton.css';

interface LinkButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'className'> {
  children: ReactNode;
}

export function LinkButton({ children, type = 'button', ...rest }: LinkButtonProps) {
  return <button className={linkButton} type={type} {...rest}>{children}</button>;
}
